import axios from 'axios'
import { RedFunnelAPI } from './redFunnelAPI'

export const redFunnelAPI = new RedFunnelAPI(axios, {
  clientId: process.env.REACT_APP_CLIENT_ID,
  dolliEndpoint: process.env.REACT_APP_DOLLI_ENDPOINT,
  // Site alerts are served by Drupal, not Dolli - see getSiteAlerts.
  drupalEndpoint: process.env.REACT_APP_DRUPAL_HOME,
  crypto: window.crypto,
})
